import React from 'react'
import { Navigate } from 'react-router-dom'

import { DashboardRoutes as dashboardRoutes } from '../pages/Dashboard'
import { DataSetupRoutes as dataSetupRoutes } from '../pages/DataSetup'
import { SettingsRoutes as settingsRoutes } from '../pages/Settings'
import themeExamplesRoutes from '../pages/ThemeComponentsexamples/ThemeExamplesRoutes'
import restaurantMenuRoutes from '../pages/RestaurantMenu/RestaurantMenuRoutes'
import { POSRoutes as posRoutes } from '../pages/POS'
import { KDSRoutes as kdsRoutes } from '../pages/KDS'
import { GuestHubAdminRoutes as guestHubAdminRoutes } from '../pages/GuestHubAdmin'
import { ReportsRoutes as reportsRoutes } from '../pages/Reports'

const redirectRoute = [
    {
        path: '/',
        exact: true,
        component: () => <Navigate to="/dashboard" />,
    },
]

const errorRoute = [
    {
        component: () => <Navigate to="/session/404" replace />,
    },
]

const routes = [
    ...redirectRoute,
    ...dashboardRoutes,
    ...dataSetupRoutes,
    ...settingsRoutes,
    ...themeExamplesRoutes,
    ...restaurantMenuRoutes,
    ...posRoutes,
    ...kdsRoutes,
    ...guestHubAdminRoutes,
    ...reportsRoutes,
    ...errorRoute,
    { path: '*', component: () => <Navigate to="/session/404" replace /> },
]

export default routes